import React, { Component } from 'react';
import './E404.css';

//Components
import Header from '../Components/Header';
import Footer from '../Components/Footer';

class Error404 extends Component {
  render() {
    window.scrollTo(0, 0)
    return (
      <div className="error-page">
        <Header/>
        <div className="error-page-content">
          <h5>There's nothing in here</h5>
          </div>
        <Footer/>
      </div>
    )
  }
};

export default Error404;



// WEBPACK FOOTER //
// ./src/Errors/E404.js